export enum localProductsActionTypes {
    FETCHING_CATEGORIES_START= "FETCHING_CATEGORIES_START",
    FETCHING_CATEGORIES_FAILED= "FETCHING_CATEGORIES_FAILED",
    FETCHING_CATEGORIES_SUCCESS= "FETCHING_CATEGORIES_SUCCESS"
}

